import ngInfiniteScroll from 'ng-infinite-scroll';

angular.module('PinMeTo.sidebar', []);
angular.module('PinMeTo.extras', []);
angular.module('PinMeTo.userSettings', []);
angular.module('PinMeTo.switchAccount', []);
angular.module('PinMeTo.splitView', ['LocalStorageModule']);
angular.module('PinMeTo.directives', [ngInfiniteScroll]);
angular.module('PinMeTo.services', []);
angular.module('PinMeTo.elm', []);
angular.module('PinMeTo.acl', []);
angular.module('PinMeTo.access', []);
angular.module('PinMeTo.edit', []);
angular.module('PinMeTo.filters', []);
angular.module('PinMeTo.savedFilters', []);
angular.module('PinMeTo.featureFlag', []);
angular.module('PinMeTo.selectors', []);
angular.module('PinMeTo.notifications', []);
angular.module('PinMeTo.workerLog', []);
angular.module('PinMeTo.UI', []);
angular.module('PinMeTo.fileManager', []);
angular.module('PinMeTo.insights', []);

angular.module('PinMeTo', [
	'PinMeTo.sidebar',
	'PinMeTo.extras',
	'PinMeTo.splitView',
	'PinMeTo.userSettings',
	'PinMeTo.switchAccount',
	'PinMeTo.directives',
	'PinMeTo.services',
	'PinMeTo.elm',
	'PinMeTo.acl',
	'PinMeTo.access',
	'PinMeTo.edit',
	'PinMeTo.filters',
	'PinMeTo.savedFilters',
	'PinMeTo.featureFlag',
	'PinMeTo.selectors',
	'PinMeTo.notifications',
	'PinMeTo.workerLog',
	'PinMeTo.UI',
	'PinMeTo.fileManager',
	'PinMeTo.insights',
	'LocalStorageModule',
	'ngWebSocket'
]);
